import { render, staticRenderFns } from "./ShopHeader.vue?vue&type=template&id=732c0c6e&"
import script from "./ShopHeader.vue?vue&type=script&lang=js&"
export * from "./ShopHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('732c0c6e')) {
      api.createRecord('732c0c6e', component.options)
    } else {
      api.reload('732c0c6e', component.options)
    }
    module.hot.accept("./ShopHeader.vue?vue&type=template&id=732c0c6e&", function () {
      api.rerender('732c0c6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/ShopHeader.vue"
export default component.exports